// Sidebar.js
import React from "react";
import { useTranslation } from "react-i18next";
import LayerItem from "./LayerItem";

const Sidebar = ({ layers, onToggle, isLight }) => {
  const { t } = useTranslation();
  return (
    <div>
      <h2 style={{ fontSize: "18px", color: "#005e95", textAlign: "center", borderBottom: "1px solid #eee", paddingBottom: "10px" }}>
        {t("რუკის ფენები")}
      </h2>
      {layers.length > 0 ? (
        layers.map((layer) => (
          <LayerItem
            key={layer.uniqueKey}
            layer={layer}
            onToggle={onToggle}
            isLight={isLight} />
        ))
      ) : (
        <p style={{ textAlign: "center", color: "#888" }}>{t("იტვირთება...")}</p>
      )}
    </div>
  );
};

export default Sidebar;